import InputDate from "@/Components/Base/Input/InputDate";
import InputPreco from "@/Components/Base/Input/InputPreco";
import { TypeInscricaoDoAlunoNaViagem } from "@/Models/Domain/Viagem/InscricaoDoAlunoNaViagem";
import { IInscricaoAlterarProvedorParams } from "@/Services/Domain/Viagem/InscricaoService";
import { Col, Form, FormProps, Input, InputNumber, Row } from "antd";
import dayjs, { Dayjs } from "dayjs";
import { useEffect } from "react";
import ProvedorPgtoSelect from "../../Financeiro/ProvedorPgto/ProvedorPgtoSelect";
export interface IInscricaoProvedorPgtoFormBasicProps extends FormProps<IInscricaoAlterarProvedorParams> {
    inscricao : TypeInscricaoDoAlunoNaViagem;
}

export interface IInscricaoProvedorPgtoInscricaoParamsFormType extends IInscricaoAlterarProvedorParams {

}

export default function InscricaoProvedorPgtoFormBasic({
    inscricao,
    form: formParam,
    disabled,
    component,
    layout,
    autoComplete,
    ...rest
}:IInscricaoProvedorPgtoFormBasicProps) {
    let dataVencimentoInicial:Date|dayjs.Dayjs = (inscricao.titulo?.dataVencimento ?? (inscricao.viagem?.prazoDeInscricao ?? inscricao.viagem?.fim)) as Date|dayjs.Dayjs;
    if (typeof dataVencimentoInicial === "string")
        dataVencimentoInicial = dayjs(dataVencimentoInicial);
    
    const valorInicial : IInscricaoProvedorPgtoInscricaoParamsFormType|undefined = inscricao?.codigo !== undefined && inscricao?.codigo > 0 ? {
        codInscricao : inscricao.codigo,
        codProvedorConciliacao : inscricao?.codProvedorPagamento ?? undefined
    } as IInscricaoProvedorPgtoInscricaoParamsFormType : undefined;

    useEffect(() => {
        formParam?.resetFields();
    }, [inscricao]);

    return <Form
        {...rest}
        form={formParam}
        disabled={disabled}
        component={component ?? "div"}
        layout={layout ?? "vertical"}
        autoComplete={autoComplete ?? "off"}
        initialValues={valorInicial}
    >
        <Row gutter={8} wrap>
            <Form.Item<IInscricaoProvedorPgtoInscricaoParamsFormType>
                name={"codInscricao"}
                label={"Código da Inscrição"}
                rules={[{ required: true, message: "Por favor, informe a inscrição" }]}
                hidden
            >
                <Input hidden /> 
            </Form.Item>
            
            <Col xs={24} sm={24} md={24} lg={24} xl={24} xxl={24}>
                <Form.Item<IInscricaoProvedorPgtoInscricaoParamsFormType>
                    name={"codProvedorConciliacao"}
                    label={"Provedor Pgto."}
                >
                    <ProvedorPgtoSelect placeholder={"Padrão"} />
                </Form.Item>
            </Col>
        </Row>
    </Form>
}